import { atom } from 'jotai'
import {
  Contact,
  ContactCase,
  ContactInstrument,
  ContactInstrumentDecisionStep,
} from 'types/contacts'

export const contactAtom = atom<Contact>({} as Contact)
export const editingContactAtom = atom(false)
export const contactInstrumentAtom = atom<ContactInstrument>({} as ContactInstrument)
export const editingContactInstrumentAtom = atom(false)
export const contactCaseCountAtom = atom<number>()
export const contactCaseAtom = atom<ContactCase>({} as ContactCase)
export const contactInstrumentDecisionStepAtom = atom<ContactInstrumentDecisionStep>(
  ContactInstrumentDecisionStep.CONTACT_DECISION
)
